import React from 'react';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import ButtonCrudAction from '../ButtonCrudAction';

const RadioButton = ({ label = '', onClick, selected, value }) => {
    const className = selected ? 'custom-radio-btn-selected' : '';

    const handleClick = () => {
        onClick(value);
    };

    return (
        <ButtonCrudAction classNames={[className]} onClick={handleClick}>
            <Literal literal={label} />
        </ButtonCrudAction>
    );
};

RadioButton.propTypes = {
    selected: PropTypes.bool,
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default RadioButton;
